"use client";

import { useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import Container from "../Container";
import CustomImage from "../CustomImage";
import Button from "../Button";
import { Link, usePathname } from "@/navigation";
import { useWindowSize } from "@/hooks/useWindowSize";
import { useScroll } from "@/hooks/useScroll";

type HeaderLinkType = {
  text: string;
  link: string;
  target?: string;
};

const Header = () => {
  const t = useTranslations("common.header");
  const [isActive, setIsActive] = useState(false);
  const [showScrolledClass, setShowScrolledClass] = useState(false);
  const { width } = useWindowSize();
  const pathname = usePathname();
  const scrollY = useScroll();

  useEffect(() => {
    if (width > 1200) {
      document.body.classList.remove("no-scroll");
    }

    if (isActive && width <= 1200) {
      document.body.classList.add("no-scroll");
    }
  }, [width, isActive]);

  useEffect(() => {
    if (scrollY > 100) {
      setShowScrolledClass(true);
    } else {
      setShowScrolledClass(false);
    }
  }, [scrollY]);

  useEffect(() => {
    document.body.classList.remove("no-scroll");
  }, []);

  return (
    <header
      className={`header ${isActive ? "header--active" : ""} ${
        showScrolledClass ? "header--scrolled" : ""
      }`.trim()}
    >
      <Container>
        <div className="header__content">
          <Link className="header__logo-link" href="/" lang="ru">
            <CustomImage
              alt={t("logo.alt")}
              src={t("logo.src.desktop")}
              srcTablet={t("logo.src.tablet")}
              srcMobile={t("logo.src.mobile")}
              className="header__logo"
              isPriority
            />
            <CustomImage
              alt={t("logo.alt")}
              src={"/assets/images/logo/nw-logo-text.svg"}
              srcTablet={"/assets/images/logo/nw-logo-text.svg"}
              srcMobile={"/assets/images/logo/nw-logo-text.svg"}
              className="header__logo-text"
            />
          </Link>
          <div className="header__links-and-button">
            <ul className="header__links">
              {t.raw("links").map((item: HeaderLinkType) => (
                <li
                  className={`header__item ${
                    pathname === item.link ? "header__item--active" : ""
                  }`.trim()}
                  key={item.text}
                >
                  {item.target ? (
                    <a
                      href={item.link}
                      target="_blank"
                      className="header__link"
                      onClick={() => {
                        setIsActive(false);
                        document.body.classList.remove("no-scroll");
                      }}
                    >
                      {item.text}
                    </a>
                  ) : (
                    <Link
                      href={item.link}
                      className="header__link"
                      onClick={() => {
                        setIsActive(false);
                        document.body.classList.remove("no-scroll");
                      }}
                    >
                      {item.text}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
            <a
              onClick={() => {
                setIsActive(false);
                document.body.classList.remove("no-scroll");
              }}
              target="_blank"
              rel="noopener noreferrer"
              className="header__button"
              href={process.env.NEXT_PUBLIC_PORTAL_URL + t("button.link")}
            >
              <span>{t("button.text")}</span>
            </a>
          </div>
          <button
            className="header__hamburger"
            onClick={() => {
              if (isActive) {
                document.body.classList.remove("no-scroll");
              } else {
                document.body.classList.add("no-scroll");
              }
              setIsActive((prev) => !prev);
            }}
          >
            <span className="header__line header__line-1"></span>
            <span className="header__line header__line-2"></span>
            <span className="header__line header__line-3"></span>
          </button>
        </div>
      </Container>
    </header>
  );
};

export default Header;

// {
//   "text": "главная",
//   "link": "/"
// },
// {
//   "text": "Академия",
//   "link": "/academy"
// },
// {
//   "text": "Подписка",
//   "link": "/media-library"
// },
// {
//   "text": "Пути",
//   "link": "/paths"
// },
// {
//   "text": "Возможности",
//   "link": "/career-and-partnership"
// },
// {
//   "text": "Сатья Ео’Тхан",
//   "link": "/sathya-eo-than"
// },
// {
//   "text": "Бали 2025",
//   "link": "https://lp.naturesway.co/atmavita",
//   "target": "_blank"
// }
